import { render } from "./sbcpDocSgn.vue?vue&type=template&id=52766613&scoped=true"
import script from "./sbcpDocSgn.vue?vue&type=script&lang=js"
export * from "./sbcpDocSgn.vue?vue&type=script&lang=js"

import "./sbcpDocSgn.vue?vue&type=style&index=0&id=52766613&scoped=true&lang=css"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52766613"]])

export default __exports__